<template>
  <Modal position="end" ref="modalRef">
    <template #header>Description</template>
    <template #body>
      <PropertyDescriptionForm ref="formRef" />
    </template>
    <template #footer>
      <Button variant="ghost" @click="modalRef?.close">Cancel</Button>
      <Button @click="save" :disabled="formRef?.isGeneratingDescription" :loading="formRef?.form.submitting">
        Save
      </Button>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { ref } from 'vue';

import { Button, Modal } from '@tallo/design-system';
import { PropertyDescriptionForm } from '@tallo/investor/property';

const modalRef = ref<InstanceType<typeof Modal>>();
const formRef = ref<InstanceType<typeof PropertyDescriptionForm>>();

async function save() {
  await formRef.value?.save();

  modalRef.value?.close();
}

defineExpose({ modalRef });
</script>
